export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACRT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export const rrfConfig = {
  userProfile: "users",
  useFirestoreForProfile: true, // Store in Firestore instead of Real Time DB
};

export const square = {
  appId: process.env.REACT_APP_SQUARE_APP_ID,
  locationId: process.env.REACT_APP_SQUARE_LOCATION_ID,
};

export const cryptoConfig = {
  publicKey: process.env.REACT_APP_PUBLIC_KEY,
};

const config = {
  firebaseConfig,
  rrfConfig,
  cryptoConfig,
};
export default config;
